import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["source", "icon", "feedback"]
  static values = {
    resetAfterMs: { type: Number, default: 2500 },
    successMessage: String,
    errorMessage: String
  }

  connect() {
    this.resetTimer = null
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }

  async copy() {
    const text = this.sourceTarget.value
    if (!text) return

    try {
      if (!navigator.clipboard?.writeText) throw new Error("Clipboard API unavailable")

      await navigator.clipboard.writeText(text)
      this.flashSuccess()
    } catch {
      this.flashError()
    }
  }

  flashSuccess() {
    this.flash({ iconClass: "text-success", feedbackClass: "text-success", message: this.successMessageValue })
  }

  flashError() {
    this.flash({ iconClass: "text-danger", feedbackClass: "text-danger", message: this.errorMessageValue })
  }

  flash({ iconClass, feedbackClass, message }) {
    clearTimeout(this.resetTimer)
    this.clearFeedback()
    this.iconTarget.classList.add(iconClass)
    this.feedbackTarget.textContent = message
    this.feedbackTarget.classList.add(feedbackClass)
    this.feedbackTarget.classList.remove("d-none")
    this.resetTimer = setTimeout(() => this.clearFeedback(), this.resetAfterMsValue)
  }

  clearFeedback() {
    this.iconTarget.classList.remove("text-success", "text-danger")
    this.feedbackTarget.classList.remove("text-success", "text-danger")
    this.feedbackTarget.classList.add("d-none")
    this.feedbackTarget.textContent = this.successMessageValue
  }
}
